export class TreeMapConfig {
  colors: Array<string>;
  constructor(colors: Array<string>) {
    this.colors = colors || [];
  }
}